import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/', { replace: true });
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const user = await loginWithGoogle(sessionId);
        const roleMap = { client: '/client', interpreter: '/interpreter', admin: '/admin', org_admin: '/org-admin' };
        navigate(roleMap[user.role] || '/client', { replace: true });
      } catch {
        navigate('/', { replace: true });
      }
    })();
  }, [loginWithGoogle, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <Loader2 className="w-8 h-8 animate-spin text-[hsl(var(--brand))] mx-auto" />
        <p className="text-sm text-muted-foreground">Signing you in...</p>
      </div>
    </div>
  );
}
